import { setCompanyManagerData, setContactManagerData, setEntityFields } from "./order"

export const setContragentData = ({type, entity, orderFieldsSettings, amoCfs, users, features, data}) => {
    
    const managerId = entity?.responsible_user_id
    
    if (type == 1){
        data['is_company'] = 0
        data['contact_id'] = entity['id'].toString();
        data['contact_short_name'] = entity['name'];
        setEntityFields(orderFieldsSettings, amoCfs, 'contact', entity, data)

        if (managerId && features.includes('responsible-user-amo-to-1c')) setContactManagerData(data, users, managerId)
    } else if (type == 3){
        data['is_company'] = 1
        data['company_id'] = entity['id'].toString();
        data['company_short_name'] = entity['name'];
        setEntityFields(orderFieldsSettings, amoCfs, 'company', entity, data)
        if (managerId && features.includes('responsible-user-amo-to-1c')) setCompanyManagerData(data, users, managerId)
    }

    return data
}